import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const invoiceBatchingOptionsAdapter = getAdapter({ idFieldName: 'value' });

const invoiceBatchingOptionsSlice = createSlice({
  name: 'invoiceBatchingOptions',
  initialState: invoiceBatchingOptionsAdapter.getInitialState(),
  reducers: {
    setInvoiceBatchingOptions: (state, { payload: { invoiceBatchingOptions } }) => {
      invoiceBatchingOptionsAdapter.setAll(state, invoiceBatchingOptions);
    },
  },
});

const selectors = invoiceBatchingOptionsAdapter.getSelectors(({ invoiceBatchingOptions }) => invoiceBatchingOptions);

export const getInvoiceBatchingOptions = (state) => selectors.selectAll(state);

export const {
  setInvoiceBatchingOptions,
} = invoiceBatchingOptionsSlice.actions;

export default invoiceBatchingOptionsSlice.reducer;
